export const deadlineTemplatesFormFieldMapping = {

  "Listing Expires": "Date Listing Ends",   // for either buyer or seller
  // Not a deadline itself, but reuses the same {title -> pdfFieldName} mapping
  // mechanism so the signing-complete suggestion (see suggestListingContractDateFromSignedDoc
  // in firestoreService.js) can find the right field name on each agency agreement form.
  "Listing Contract Date": "Date Listing Contract Date",   // for either buyer or seller
  "Revive Contract Acceptance Deadline": "Date Revive Contract Acceptance Deadline",
// CBS
  "Alternative Earnest Money Deadline":
    "DateAlternative Earnest Money Deadline",
  "Record Title Deadline (and Tax Certificate)":
    "DateRecord Title Deadline and Tax Certificate",
  "Record Title Objection Deadline": "DateRecord Title Objection Deadline",
  "Off-Record Title Deadline": "DateOffRecord Title Deadline",
  "Off-Record Title Objection Deadline":
    "DateOffRecord Title Objection Deadline",
  "Title Resolution Deadline": "DateTitle Resolution Deadline",
  "Third Party Right to Purchase/Approve Deadline":
    "DateThird Party Right to PurchaseApprove Deadline",
    "Association Documents Deadline": "DateAssociation Documents Deadline",
    "Association Documents Termination Deadline": "DateAssociation Documents Termination Deadline",
    "Seller's Property Disclosure Deadline": "DateSellers Property Disclosure Deadline",
    "Lead-Based Paint Disclosure Deadline": "DateLeadBased Paint Disclosure Deadline",
    "New Loan Application Deadline": "DateNew Loan Application Deadline",
    "New Loan Terms Deadline": "DateNew Loan Terms Deadline",
    "New Loan Availability Deadline": "DateNew Loan Availability Deadline",
    "Buyer's Credit Information Deadline": "DateBuyers Credit Information Deadline",
    "Disapproval of Buyer's Credit Information Deadline": "DateDisapproval of Buyers Credit Information Deadline",
    "Existing Loan Deadline": "DateExisting Loan Deadline",
    "Existing Loan Termination Deadline": "DateExisting Loan Termination Deadline",
    "Loan Transfer Approval Deadline": "DateLoan Transfer Approval Deadline",
    "Seller or Private Financing Deadline": "DateSeller or Private Financing Deadline",
    "Appraisal Deadline": "DateAppraisal Deadline",
    "Appraisal Objection Deadline": "DateAppraisal Objection Deadline",
    "Appraisal Resolution Deadline": "DateAppraisal Resolution Deadline",
    "New ILC or New Survey Deadline": "DateNew ILC or New Survey Deadline",
    "New ILC or New Survey Objection Deadline": "DateNew ILC or New Survey Objection Deadline",
    "New ILC or New Survey Resolution Deadline": "DateNew ILC or New Survey Resolution Deadline",
    "Water Rights Examination Deadline": "DateWater Rights Examination Deadline",
    "Mineral Rights Examination Deadline": "DateMineral Rights Examination Deadline",
    "Inspection Termination Deadline": "DateInspection Termination Deadline",
    "Inspection Objection Deadline": "DateInspection Objection Deadline",
    "Inspection Resolution Deadline": "DateInspection Resolution Deadline",
    "Property Insurance Termination Deadline": "DateProperty Insurance Termination Deadline",
    "Due Diligence Documents Delivery Deadline": "DateDue Diligence Documents Delivery Deadline",
    "Due Diligence Documents Objection Deadline": "DateDue Diligence Documents Objection Deadline",
    "Due Diligence Documents Resolution Deadline": "DateDue Diligence Documents Resolution Deadline",
    "Conditional Sale Deadline": "DateConditional Sale Deadline",
    "Lead Based Paint Termination Deadline": "DateLeadBased Paint Termination Deadline",
    "Possession Date": "DatePossession Date",
    "Acceptance Deadline Date": "DateAcceptance Deadline Date",
    "Acceptance Extension or Termination Deadline": "DateAcceptance Extension or Termination Deadline",
  "Closing Date": "DateClosing Date",
  "UCC and Certificate of Title Deadline": "DateUCC and Certificate of Title Deadline",
  "UCC and Certificate of Title Objection Deadline": "DateUCC and Certificate of Title Objection Deadline",
  "UCC and Certificate of Title Resolution Deadline": "DateUCC and Certificate of Title Resolution Deadline",
  "Lease Delivery Deadline": "DateLease Delivery Deadline",
  "Lot Owner Approval Deadline": "DateLot Owner Approval Deadline",
  "Lease Review Termination Deadline": "DateLease Review Termination Deadline",
  "Revive Acceptance Deadline": "DateRevive Acceptance Deadline",
  "Counterproposal Acceptance Deadline": "DateCounterproposal Acceptance Deadline",
  "Amendment Acceptance Deadline": "DateAmendment Acceptance Deadline",
  "Extend or Terminate Deadline": "DateExtend or Terminate Deadline",
  "Environmental Inspection Termination Deadline": "DateEnvironmental Inspection Termination Deadline",
  "ADA Evaluation Termination Deadline": "DateADA Evaluation Termination Deadline",
  "Estoppel Statements Deadline": "DateEstoppel Statements Deadline",
  "Estoppel Statements Termination Deadline": "DateEstoppel Statements Termination Deadline",
  "Short Sale Acceptance Deadline": "DateShort Sale Acceptance Deadline", 
};

export const deadlineMilestonesMapping = {
      "Acceptance Deadline Date": "DateAcceptance Deadline Date",

  "Alternative Earnest Money Deadline":
    "DateAlternative Earnest Money Deadline",
  "Record Title Deadline (and Tax Certificate)":
    "DateRecord Title Deadline and Tax Certificate",
  "Record Title Objection Deadline": "DateRecord Title Objection Deadline",
  "Off-Record Title Deadline": "DateOffRecord Title Deadline",
  "Off-Record Title Objection Deadline":
    "DateOffRecord Title Objection Deadline",
  "Title Resolution Deadline": "DateTitle Resolution Deadline",
  "Third Party Right to Purchase/Approve Deadline":
    "DateThird Party Right to PurchaseApprove Deadline",
    "Association Documents Deadline": "DateAssociation Documents Deadline",
    "Association Documents Termination Deadline": "DateAssociation Documents Termination Deadline",
    "Seller's Property Disclosure Deadline": "DateSellers Property Disclosure Deadline",
    "Lead-Based Paint Disclosure Deadline": "DateLeadBased Paint Disclosure Deadline",
    "New Loan Application Deadline": "DateNew Loan Application Deadline",
    "New Loan Terms Deadline": "DateNew Loan Terms Deadline",
    "New Loan Availability Deadline": "DateNew Loan Availability Deadline",
    "Buyer's Credit Information Deadline": "DateBuyers Credit Information Deadline",
    "Disapproval of Buyer's Credit Information Deadline": "DateDisapproval of Buyers Credit Information Deadline",
    "Existing Loan Deadline": "DateExisting Loan Deadline",
    "Existing Loan Termination Deadline": "DateExisting Loan Termination Deadline",
    "Loan Transfer Approval Deadline": "DateLoan Transfer Approval Deadline",
    "Seller or Private Financing Deadline": "DateSeller or Private Financing Deadline",
    "Appraisal Deadline": "DateAppraisal Deadline",
    "Appraisal Objection Deadline": "DateAppraisal Objection Deadline",
    "Appraisal Resolution Deadline": "DateAppraisal Resolution Deadline",
    "New ILC or New Survey Deadline": "DateNew ILC or New Survey Deadline",
    "New ILC or New Survey Objection Deadline": "DateNew ILC or New Survey Objection Deadline",
    "New ILC or New Survey Resolution Deadline": "DateNew ILC or New Survey Resolution Deadline",
    "Water Rights Examination Deadline": "DateWater Rights Examination Deadline",
    "Mineral Rights Examination Deadline": "DateMineral Rights Examination Deadline",
    "Inspection Termination Deadline": "DateInspection Termination Deadline",
    "Inspection Objection Deadline": "DateInspection Objection Deadline",
    "Inspection Resolution Deadline": "DateInspection Resolution Deadline",
    "Property Insurance Termination Deadline": "DateProperty Insurance Termination Deadline",
    "Due Diligence Documents Delivery Deadline": "DateDue Diligence Documents Delivery Deadline",
    "Due Diligence Documents Objection Deadline": "DateDue Diligence Documents Objection Deadline",
    "Due Diligence Documents Resolution Deadline": "DateDue Diligence Documents Resolution Deadline",
    "Conditional Sale Deadline": "DateConditional Sale Deadline",
    "Lead Based Paint Termination Deadline": "DateLeadBased Paint Termination Deadline",
  "UCC and Certificate of Title Deadline": "DateUCC and Certificate of Title Deadline",
  "UCC and Certificate of Title Objection Deadline": "DateUCC and Certificate of Title Objection Deadline",
  "UCC and Certificate of Title Resolution Deadline": "DateUCC and Certificate of Title Resolution Deadline",
  "Lease Delivery Deadline": "DateLease Delivery Deadline",
  "Lot Owner Approval Deadline": "DateLot Owner Approval Deadline",
  "Lease Review Termination Deadline": "DateLease Review Termination Deadline",
  "Environmental Inspection Termination Deadline": "DateEnvironmental Inspection Termination Deadline",
  "ADA Evaluation Termination Deadline": "DateADA Evaluation Termination Deadline",
  "Estoppel Statements Deadline": "DateEstoppel Statements Deadline",
  "Estoppel Statements Termination Deadline": "DateEstoppel Statements Termination Deadline",
    "Closing Date": "DateClosing Date",
        "Possession Date": "DatePossession Date",


    "Listing Expires": "Date Listing Ends",   // for either buyer or seller  

};
